import React, { Component } from 'react'
import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbSeparator,
    BreadcrumbPage,
} from '@/components/ui/breadcrumb'
import { NavLink } from 'react-router-dom'
import _kebabCase from 'lodash/kebabCase'

import Home from '../pages/Home'
import Utils from './Utils'

class BreadcrumbCard extends Component {
    constructor(props) {
        super(props)
        this.breadcrumbs = props.breadcrumbs.map(breadcrumb => {
            // NOTE: this is super-messy.. let's clean it up starting from the ToolRegistry
            if (typeof breadcrumb.title === 'object' && breadcrumb.title.title) {
                return {
                    title: breadcrumb.title.title,
                    href: breadcrumb.title.link || breadcrumb.href || '/' + _kebabCase(breadcrumb.title.title),
                    active: breadcrumb.active,
                }
            }
            return {
                title: breadcrumb.title,
                href: breadcrumb.href || '/' + _kebabCase(breadcrumb.title),
                active: breadcrumb.active,
            }
        })
        if (!props.isHome) {
            this.breadcrumbs.unshift({
                title: Home.getTitle(),
                href: "/",
            })
        }
    }

    render() {
        const props = Object.assign({}, this.props)
        delete props.breadcrumbs
        delete props.noBorder
        delete props.isHome

        const notchStyle = Utils.getNotchStyle()

        // Both noBorder and normal case use the same padded wrapper —
        // individual tool cards (FormText, FormCode, ToolTable, etc.) provide
        // their own borders/rounded corners, sitting at the same gap from the
        // viewport edges as GlossaryCard (mx-2 my-2).
        const children = (
            <div className={ "px-2 py-2 " + notchStyle }>
                { this.props.children }
            </div>
        )

        return (
            <div {...props}>
                <div id="breadcrumb" className={ "bg-muted/40 px-4 py-2 " + notchStyle }>
                    <Breadcrumb>
                        <BreadcrumbList>
                            {this.breadcrumbs.map((breadcrumb, idx) => {
                                return (
                                    <React.Fragment key={ breadcrumb.href + idx }>
                                        { idx > 0 && <BreadcrumbSeparator /> }
                                        <BreadcrumbItem>
                                            { breadcrumb.active
                                                ? <BreadcrumbPage data-cy="breadcrumbLastItem">{ breadcrumb.title }</BreadcrumbPage>
                                                : <BreadcrumbLink
                                                    render={ <NavLink to={ breadcrumb.href } /> }
                                                    className="inline-flex items-center transition-colors hover:text-foreground">
                                                    { breadcrumb.title }
                                                  </BreadcrumbLink>
                                            }
                                        </BreadcrumbItem>
                                    </React.Fragment>
                                )
                            })}
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
                <div id="tool-body" className={ notchStyle }>{ children }</div>
            </div>
        )
    }
}

export default BreadcrumbCard
